// Modules
import axios from "axios";
import { useEffect, useState } from "react";
import { useDrag, useDrop } from 'react-dnd';
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";

// CSS
import '_Asset/css/Admin/Page/admin.css';

// API
import { AdKmCatApi, AdKmGetApi, AdKmIdxApi } from "_Route/Api";

// Component
import Loading from "Admin/Component/Loading";
import { useRef } from "react";


let requestData = []
const ChildMenu = ({child, depth = 1, callId, index, adKmMenu, update, setUpdate, userScore, adTreeMenu, setAdTreeMenu, catList}) => {
  
  const navigate = useNavigate()
  const params = useParams();
  
  const curDate = new Date(); // 현재 시간
  const curDay = 24 * 60 * 60 * 1000 // h * m * s * ms
  const hasChildren = child.children && child.children.length; // 다음 Depth가 존재하는지 체크 [boolean]
  const [open, setOpen] = useState(false);
  
  // 현재 드래그 중인 메뉴 리스트
  let curDepthMenu = [];
  
  if (child.km_depth === 0) { // 이동 대상 메뉴의 Depth가 0일때
    curDepthMenu = adKmMenu.filter(key => key.km_depth === 0 && child.km_group === key.km_group)
  } else { // Depth가 0이 아닐때
    curDepthMenu = adKmMenu.filter(key => key.km_depth !== 0 && key.km_parent === child.km_parent) // 부모 ID가 같은 메뉴들만 찾음
  }


  /* ========================================================================
  * 새로고침시 현재 메뉴 및 상위 메뉴 Active 적용
  ======================================================================== */
  const [isActive, setIsActive] = useState(false)

  const fsActive = (curChild) => {
    if (curChild.km_id === params.id) {
      setIsActive(true);
    } else {
      if(curChild.children) {
        curChild.children?.map(key => {
          fsActive(key)
        })
      }
    }
  }

  useEffect(() => {
    fsActive(child)
  }, [])


  /* ========================================================================
  * Drag and Drop 변경 데이터 재구성 함수
  ======================================================================== */
  const itemFn = (dataList, dataItem) => {
    for(let i in dataList) {

      // Drag 기존 데이터 삭제
      if(dataList[i].km_id === dataItem.km_id){
        const findIdx = dataList.indexOf(dataItem)
        if(findIdx > -1){
          dataList.splice(findIdx, 1)
        }
      }

      // Drag 데이터 이동
      if (dataList[i]) {
        if (dataList[i].km_id === child.km_id){

          if (!hasChildren && curRect === "DOWN") {

            const minusIdx = !(child.km_depth === 0 && dataItem.km_depth === 0) && child.km_parent !== dataItem.km_parent ? 0 : 1
            
            dataItem.km_parent = dataList[index - minusIdx].km_id
            dataItem.km_depth = dataList[index - minusIdx].km_depth + 1

            dataList[index - minusIdx].children = [dataItem]
            return dataList[index - minusIdx]?.children

          } else {
            if (child.km_depth === 0) {
              dataItem.km_parent = dataItem.km_id
            } else {
              dataItem.km_parent = dataList[index].km_parent
            }
            dataItem.km_depth = dataList[index].km_depth
            dataList.push(dataItem);
          }
        }

        // Drag 아이템 찾기
        if(dataList[i].children){
          let childItems = dataList[i].children;
          itemFn(childItems, dataItem);
        }
      }
    }
  }

  const reconst = (data) => {
    const curMenu = adTreeMenu.find(key => key[0] === child.km_grp)
    const orgDataList = curMenu[1];
    itemFn(orgDataList, data)
  }


  // 메뉴 Drop시 Event 함수
  const dropEvent = (draggedId, orgIndex, index) => {
    
    let draggedMenu = adKmMenu.find(key => key.km_id === draggedId)


    // 현재 드래그 중인 메뉴 (draggedMenuList), 대상 메뉴 (curDepthMenu) 찾기
    let draggedMenuList = [];
    if (draggedMenu.km_depth === 0) { // 이동 대상 메뉴의 Depth가 0일때
      draggedMenuList = adKmMenu.filter(key => key.km_depth === 0 && child.km_group === key.km_group)
    } else { // Depth가 0이 아닐때
      draggedMenuList = adKmMenu.filter(key => key.km_depth !== 0 && key.km_parent === draggedMenu.km_parent)
    }

    // console.log(index, orgIndex, hasChildren, "index, origin Index, hasChildren")

    // 드래그한 대상의 메뉴가 서로 다를 때
    if ((!(child.km_depth === 0 && draggedMenu.km_depth === 0) && (child.km_parent !== draggedMenu.km_parent || (child.km_parent === draggedMenu.km_parent && child.km_depth === 0))) || child.km_grp !== draggedMenu.km_grp) {
      // console.log("대상 다름")

      const changeCurIdxArr = curDepthMenu.filter(key => key.km_depth_index >= index)
      const changeDraggedIdxArr = draggedMenuList.filter(key => key.km_depth_index > orgIndex)
      // console.log(curDepthMenu, draggedMenuList,"????????????????????????")

      // 드래그한 대상 메뉴 Index 정렬
      changeCurIdxArr.map(key => {
        key.km_depth_index = key.km_depth_index + 1;
      })
      // 드래그된 메뉴 Index 정렬
      changeDraggedIdxArr.map(key => {
        key.km_depth_index = key.km_depth_index - 1;
      })
      draggedMenu.km_depth_index = index

    } else {
      if (orgIndex > index) { // 위쪽으로 드래그
        // console.log("Drag Up")
        const changeIdxArr = curDepthMenu.filter(key => key.km_depth_index >= index && key.km_depth_index < orgIndex)
  
        changeIdxArr.map(key => {
          key.km_depth_index = key.km_depth_index + 1;
        })
        draggedMenu.km_depth_index = index

      } else if (index - orgIndex >= 2 || (index - orgIndex >= 1 && !hasChildren)) { // 아래쪽으로 드래그
        // console.log("Drag Down")
        const changeIdxArr = curDepthMenu.filter(key => key.km_depth_index > orgIndex && key.km_depth_index < index)
  
        changeIdxArr.map(key => {
          key.km_depth_index = key.km_depth_index - 1;
        })
        draggedMenu.km_depth_index = index - 1

      } else { // 같은 자리로 드래그
        // console.log("as it is")
        return 0
      }
    }
    draggedMenu.km_group = child.km_group
    draggedMenu.km_grp = child.km_grp

    
    // 현재 메뉴의 depth_index 정렬
    curDepthMenu.sort((a, b) => {
      return a.km_depth_index - b.km_depth_index;
    })
    // curDepthMenu.map((key, i) => {
    //   key.km_depth_index = i
    // })


    // 드래그한 대상의 부모가 다를시 데이터 재구성
    // console.log(!hasChildren, curRect, "child, rect??")
    // console.log(child, draggedMenu, "????????????????")
    
    if ((!(child.km_depth === 0 && draggedMenu.km_depth === 0) && (child.km_parent !== draggedMenu.km_parent || (child.km_parent === draggedMenu.km_parent && child.km_depth === 0))) || (!hasChildren && curRect === "DOWN")) {
      reconst(draggedMenu)
    }
    if (child.km_depth > 0) {
      const parentMenu = adKmMenu.find(key => key.km_id === child.km_parent) 
      parentMenu.children.sort((a, b) => {
        return a.km_depth_index - b.km_depth_index;
      })
      parentMenu.children.map((key, i) => {
        key.km_depth_index = i
      })
    }


    // 변경된 데이터 저장
    const dropListData = curDepthMenu.filter(key => index - 1 < key.km_depth_index)
    const orgListData = draggedMenuList.filter(key => orgIndex - 1 < key.km_depth_index)
    
    requestData = requestData.concat(dropListData, orgListData, [draggedMenu])
    const duplicateSet = new Set(requestData)
    requestData = [...duplicateSet]

    setUpdate(!update) // 변경된 데이터 화면 갱신

    // console.log(adTreeMenu, "AD TREE MENU")
  }


  /* ========================================================================
  * Drag & Drop Ref
  ======================================================================== */
  // Using Drag
  const [{isDragging}, dragRef] = useDrag(() => ({      
    type: 'List',
    item: () => {
      return { callId, index, adKmMenu, catList, adTreeMenu }
    },
    collect: (monitor) => ({        
      isDragging: monitor.isDragging(),
    }),
    end: (item, monitor) => {
      const didDrop = monitor.didDrop();
      
      if(!didDrop) { // Drop 영역이 아닌 곳에 Drop시
        setUpdate(!update) // 원래 위치로 이동
      }
    }
  }),[callId, index]);


  // Using Drop [리스트 드랍]
  const hoverRef = useRef(null)
  const [curRect, setCurRect] = useState('UP')
  const [{isOver}, idxDrop] = useDrop(() => ({
    accept: 'List',
    hover({ callId: draggedId, index: orgIndex}, monitor) {
      if (!hoverRef.current) {
        return
      }
      if (index === orgIndex) {
        return
      }
      const hoverBoundingRect = hoverRef.current?.getBoundingClientRect()
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      const clientOffset = monitor.getClientOffset()
      const hoverClientY = clientOffset.y - hoverBoundingRect.top

      const bottomRect = hoverMiddleY + (hoverMiddleY / 2)
      
      if(orgIndex < index && hoverClientY < hoverMiddleY) {
        return
      }
      if(orgIndex > index && hoverClientY > hoverMiddleY) {
        return
      }
      
      if(hoverClientY >= bottomRect) {
        setCurRect('DOWN')
      } else {
        setCurRect('UP')
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
    drop({ 
      callId: dropId,
      index: orgIdx,
      adKmMenu: kmMenu,
    }) {
      dropEvent(dropId, orgIdx, index)
      setUpdate(!update)
    },
  }), [dropEvent])
  idxDrop(hoverRef)


  // 메뉴 최하단 Drop 영역
  const [{isOverBtm}, btmDrop] = useDrop(() => ({
    accept: 'List',
    hover({ callId: draggedId, index: orgIndex}, monitor) {
      if (!hoverRef.current) {
        return
      }
      if (index === orgIndex) {
        return
      }
      const hoverBoundingRect = hoverRef.current?.getBoundingClientRect()
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      const clientOffset = monitor.getClientOffset()
      const hoverClientY = clientOffset.y - hoverBoundingRect.top

      const bottomRect = hoverMiddleY + (hoverMiddleY / 2)
      
      if(orgIndex < index && hoverClientY < hoverMiddleY) {
        return
      }
      if(orgIndex > index && hoverClientY > hoverMiddleY) {
        return
      }
      if(hoverClientY <= bottomRect) {
        setCurRect('DOWN')
      } else {
        setCurRect('UP')
      }
    },
    collect: (monitor) => ({
      isOverBtm: monitor.isOver(),
    }),
    drop({ 
      callId: dropId,
      index: orgIdx,
    }) {
      dropEvent(dropId, orgIdx, index + 1)
      setUpdate(!update)
    },
  }), [dropEvent])


  return (
    <>
      <li ref={userScore >= 300 ? dragRef : null} className={`${isDragging ? 'draged' : ''}`} style={{opacity: Number(child.km_menu_use) === 0 ? 0.6 : 1}}>
        <div ref={userScore >= 300 ? hoverRef : null} data-status={isActive} data-name={child.km_title} className={`menuTitGroup ${hasChildren ? (open || isActive) && 'active' : callId === params.id && 'active'} ${parseInt((curDate - new Date(child.km_create_date)) / curDay) < 7 ? 'new' : ''} ${isOver ? 'over' : null} ${!hasChildren && curRect === 'DOWN' ? 'noChild' : ''}`} onClick={() => {!isActive && setOpen(!open); setIsActive(false)}} style={{paddingLeft: `${depth * 18}px`}}>
          <Link to={`/admin/km/view/${child.km_id}`}>
            {hasChildren ? <i className="icofont-rounded-right"></i> : <span></span>}
            <p>{child.km_title}</p>
          </Link>
          {
            userScore >= 200 &&
            <button type="button" className="icofont-plus" onClick={() => navigate(`/admin/km/add/${child.km_id}`)}></button>
          }
        </div>

        {
          ((open && hasChildren) || isActive) && 
          <ul className={`depth_${depth}`}>
            {child.children?.map((child, i) =>
              <ChildMenu
                key={i}
                child={child}
                depth={depth + 1}
                callId={child.km_id}
                index={i}
                adKmMenu={adKmMenu}
                update={update}
                setUpdate={setUpdate}
                userScore={userScore}
                adTreeMenu={adTreeMenu}
                setAdTreeMenu={setAdTreeMenu}
              />
            )}
          </ul>
        }
      </li>
      {
        curDepthMenu.length === index + 1 &&
        <li>
          <div ref={userScore >= 300 ? btmDrop : null} className={`menuTitGroup ${isOverBtm ? 'over' : ''}`}></div>
        </li>
      }
    </>
  )
}


const AdMenuItm = ({itm, index, curSpace, adKmMenu, update, setUpdate, userScore, adTreeMenu, setAdTreeMenu, catList}) => {

  // Group 카테고리 변경 함수
  const moveGroup = (draggedId, kmMenu, catList, adTreeMenu) => {

    if(titRef.current) {
      let curData = kmMenu.find(key => key.km_id === draggedId)
      let titCont = titRef.current.textContent
      const curGrpList = catList.find(key => key.km_grp === titCont)
      const curMenu = adTreeMenu.find(key => key[0] === titCont)?.[1]

      if(titCont !== curData.km_grp) {
        // 대상 데이터 변경
        curData.km_group = String(curGrpList.kmgrp_no)
        curData.km_grp = titCont
        curData.km_depth_index = curMenu?.length
  
        setUpdate(!update)
      }
    }
  }

  // KM Group 카테고리 Drop 함수
  const titRef = useRef()
  const [, menuDrop] = useDrop(() => ({
    accept: 'List',
    drop({
      callId: draggedId,
      index: dropIdx,
      adKmMenu: kmMenu,
      catList: catList,
      adTreeMenu: adTreeMenu
    }) {
      moveGroup(draggedId, kmMenu, catList, adTreeMenu)
    },
  }), [moveGroup])


  return (
    <div key={index} className="menuItm">
      {
        curSpace === '' &&
        <div ref={menuDrop}><h2 ref={titRef}><i className="icofont-file-alt" />{itm[0]}</h2></div>
      }
      <ul>
        {itm[1].map((list, idx) => 
          <ChildMenu
            key={idx}
            child={list}
            callId={list.km_id}
            index={idx}
            adKmMenu={adKmMenu}
            update={update}
            setUpdate={setUpdate}
            userScore={userScore}
            adTreeMenu={adTreeMenu}
            setAdTreeMenu={setAdTreeMenu}
            catList={catList}
          />
        )}
      </ul>
    </div>
  )
}


const AdKMMenu = ({curSpace, setCurSpace, update, setUpdate, updateMenu}) => {

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false)
  const [adKmMenu, setAdKmMenu] = useState([]) // 전체 KM Menu 
  const [adTreeMenu, setAdTreeMenu] = useState([]) // 전체 KM Tree Menu
  const [catList, setCatList] = useState([]);

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);

  const onSpace = (value) => {
    setCurSpace(value);
    sessionStorage.setItem('kmSpace', value)
    navigate("/admin/km/add")
  }


  /* ========================================================================
  * KM 데이터 조회, 생성
  ======================================================================== */
  // 트리 메뉴 생성 재귀 함수
  const treeMenu = (kmMenuData, data, state) => {    
    data.map(key => {
      const nextDepth = kmMenuData?.filter(list => key.km_id === list.km_parent && list.km_depth !== 0)
      const prevDepth = kmMenuData?.filter(list => list.km_id === key.km_parent)
      const depthChk = key.km_id === key.km_parent && state === false
      
      if (depthChk) { return 0 }
      if(nextDepth.length !== 0 && key.children === undefined) {
        key.children = nextDepth
        treeMenu(kmMenuData, nextDepth, false)
      }
      else if (nextDepth.length === 0) {
        treeMenu(kmMenuData, prevDepth, false)
      }
    })
  }


  // KM 카테고리 목록 조회
  useEffect(() => {
    axios({
      url: AdKmCatApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      setCatList(res.data.result)
    })
    .catch(err => {
      console.error(err, "GET Category List Error...");
    })
  }, [])


  // KM 메뉴 조회
  useEffect(() => {
    setLoading(false)
    axios({
      url: AdKmGetApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        type: "menu"
      }
    })
    .then(res => {
      // console.log(res, "Make tree menu object")
      const kmMenuData = res.data.result;
      setAdKmMenu(kmMenuData)

      let treeDataTemp;
      if (curSpace) {
        treeDataTemp = kmMenuData?.filter(key => key.km_id === key.km_parent && key.km_group === curSpace)
      } else {
        treeDataTemp = kmMenuData?.filter(key => key.km_id === key.km_parent)
      }
      treeMenu(kmMenuData, treeDataTemp, true)

      let newArray = []
      treeDataTemp.map(key => {
        if (!newArray[key.km_grp]) {
          newArray[key.km_grp] = []
          newArray[key.km_grp].push(key)
        } else {
          newArray[key.km_grp].push(key)
        }
      })
      setAdTreeMenu(Object.entries(newArray)); // 최종 Tree menu 데이터
    })
    .catch(err => {
      console.error(err, "GET KM Menu Error...");
    })
    .finally(() => {
      setLoading(true)
    })
  }, [curSpace, updateMenu])


  // 데이터 정렬, CS, SFRT 카테고리 변경 데이터 재구성
  useEffect(() => {
    // console.log("drag and drop update")

    adTreeMenu.map(key => {
      const menuGrp = key[0]
      const menuArr = key[1]

      const changeData = menuArr.find(f => f.km_grp !== menuGrp)
      const changeIdx = menuArr.findIndex(f => f.km_grp !== menuGrp)

      // 변경된 Group 데이터 재구성
      if(changeData) {
        menuArr.splice(changeIdx, 1)
        adTreeMenu.map(key2 => {
          if(key2[0] === changeData.km_grp) {
            key2[1].push(changeData)
          }
        })
      }

      // 데이터 오름차순 정렬
      menuArr.sort((a, b) => {
        return a.km_depth_index - b.km_depth_index;
      })
    })

    setAdTreeMenu([...adTreeMenu])
  }, [update])


  /* ========================================================================
  * Drag & Drop 기능 및 변경 데이터 적용
  ======================================================================== */
  // KM Menu 수정 API
  const EditSave = (data, idx) => {
    axios({
      method: 'PUT',
      url: AdKmIdxApi,
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        km_depth_index: data.km_depth_index,
        km_id: data.km_id,
        km_parent: data.km_parent,
        km_group: Number(data.km_group),
        km_depth: data.km_depth,
      }
    })
    .then(res => {
      // console.log("KM Drag & Drop Index Edit Success!", res)
      setUpdate(!update)
    })
    .catch(err => {
      console.error("KM Drag & Drop Index Edit Error...", err)
    })
    .finally(() => {
      if(requestData.length === idx + 1) { // 마지막 요청일시 로딩 종료
        setLoading(true)
        requestData = [];
        alert("저장이 완료되었습니다.")
      }
    })
  }

  // 변경된 데이터 최종 저장
  const menuSave = () => {
    if(requestData.length === 0) {
      alert("변경된 메뉴가 없습니다.")
      return;
    }

    if(window.confirm(`메뉴 정보가 변경되었습니다. \n정말 저장하시겠습니까?`)) {
      setLoading(false)

      requestData.map((key, i) => {
        EditSave(key, i);
      })
    }
  }

  
  return (
    <div className="adContArea menu">
      <div className="fieldGroup">
        <div className="field full">
          <select className="select sm round_10 type_1" onChange={(e) => onSpace(e.target.value)}>
            <option value="">전체</option>
            {catList.map((list, i) =>
              <option value={list.kmgrp_no} key={i}>{list.km_grp}</option>
            )}
          </select>
        </div>
      </div>

      {
        userScore >= 200 &&
        <div className="kmAddBtn">
          {
            userScore >= 300 &&
            <button type="button" className="btn xs round_10 green" onClick={() => menuSave()}>변경 사항 저장</button>
          }
          <button type="button" className="btn xs round_10 sfrtBlue" onClick={() => navigate('/admin/km/add')}>첫 메뉴 등록</button>
        </div>
      }
      {loading ?
        <div className="adKmMenu">
          {adTreeMenu.map((list, i) => 
            <AdMenuItm
              key={i}
              itm={list}
              index={i}
              curSpace={curSpace}
              adKmMenu={adKmMenu}
              update={update}
              setUpdate={setUpdate}
              userScore={userScore}
              adTreeMenu={adTreeMenu}
              setAdTreeMenu={setAdTreeMenu}
              catList={catList}
            />
          )}
        </div>
        :
        <Loading />
      }
    </div>
  )
}

export default AdKMMenu;